import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { sportIds } from 'src/constants/personalizationIds'
import { usPlanData } from 'src/constants/planData/usPlanData'
import { latinoPlanData } from 'src/constants/planData/latinoPlanData'
import styled from 'styled-components'
import { Link } from 'gatsby'

export default (props) => (
  <StyledComponent>
    <USTemplateDefault
      location={props.location}
      lang="es"
      market="us"
      // TEMPORARY NBC DISPUTE
      // video={videos.soccer.videoUrl}
      // videoMobile={videos.soccer.videoMobileUrl}
      // annotations={videos.soccer.annotations}
      poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Web.jpg"
      posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Mobile.jpg"
      title="Fubo te da más fútbol sin cable"
      subtitle="Elige entre la cobertura que quieres o el precio que necesitas"
      networkSet="soccer"
      noteLink="/soccer/"
      sportId={sportIds.Soccer}
      hasPlanCards={true}
      plans={[usPlanData.pro_soccer_es_monthly, latinoPlanData.latino_soccer_es_monthly]}
      heroCtaNote={
        <Link to={'/soccer/'}>
          To learn more in English, <span>click here</span>.
        </Link>
      }
      caRedirectUrl={'/ca/dazn/'}
    />
  </StyledComponent>
)

const StyledComponent = styled.div`
  .section-content .planCard__image::after {
    background: radial-gradient(ellipse 126% 60% at top right, transparent 50%, rgb(4, 9, 17) 100%);
  }
`
